import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		rolesInProject: []
	},

	actions: {
		fetchAll ({ commit }) {
			return window.axios.get('/Projects/Roles').then(({ data }) => {
				commit(types.ROLES_IN_PROJECT, data)
				return data
			})
		},

		create ({ commit }, { name, description }) {
			return window.axios.post('/Projects/Role', { name, description }).then(({ data }) => {
				return data
			})
		},
		
		update ({ commit }, { id, name, description }) {
			return window.axios.put(`/Projects/Role/${id}`, { name, description }).then(({ data }) => {
				return data
			})
		},

		delete ({ commit }, { id }) {
			return window.axios.delete(`/Projects/Role/${id}`)
		}
	},

	mutations: {
		[types.ROLES_IN_PROJECT] (state, rolesInProject) {
			state.rolesInProject = rolesInProject
		}
	},
	getters: {
		getRoleById: state => id => state.rolesInProject.find(c => c.id === id)
	}
}
